module.exports = __webpack_public_path__ + "img/contact.1bbc76c6.png";